import { render, staticRenderFns } from "./label-container.vue?vue&type=template&id=3ac76951"
import script from "./label-container.vue?vue&type=script&lang=ts"
export * from "./label-container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports